import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { PendingAreaContent } from '@core/models/pending-area-content.model';

export interface PendingAreaContentState extends EntityState<PendingAreaContent> {}

export function createInitialState(): PendingAreaContentState {
  return null;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'pending-area-content', idKey: 'uid', resettable: true })
export class PendingAreaContentStore extends EntityStore<PendingAreaContentState> {
  constructor() {
    super(createInitialState());
  }
}
